import { CommonPageTWCard } from '@lemon8/web-app-shared/ssr';
import { usePoiTDK } from '../shared/use-poi-tdk';
import { usePoiCover } from '../shared/use-poi-cover';

export const PoiTwitter = () => {
  const { title, description } = usePoiTDK();
  const twitterCardInfo = {
    twCardTitle: title,
    twCardDesc: description,
    twCardImageSrc: usePoiCover()?.url || '',
  };

  return <CommonPageTWCard {...twitterCardInfo} />;
};
